export default "/assets/images/app-update-img-02.c77f6cb43475384e.png";